module.exports = __webpack_public_path__ + "img/rebate_sp3.9cf924b2.png";